// What a lookup result means for the capture flow.
//   "none"   no match: a new item carrying the barcode
//   "direct" a code names one item: recapture it, no question
//   "decide" a barcode is already on file: pick an existing item or capture a new one
export function identityDecision({ candidates, noBarcode, byCode }) {
  if (noBarcode || !candidates || candidates.length === 0) return "none";
  if (byCode) return "direct";
  return "decide";
}

// Same test as PLACEHOLDER_TITLE_RE in apps/nricher/app/lib/scanUploads.jsx.
const PLACEHOLDER_TITLE_RE = /^Untitled \((barcode |[0-9A-HJKMNP-TV-Z]{8}\)$)/;

// An item's own title, or null when it has none (empty or a placeholder).
export function realTitle(c) {
  const t = c && c.title;
  return t && !c.placeholder && !PLACEHOLDER_TITLE_RE.test(t) ? t : null;
}

// What a row calls an item: its title, and its code only when it has no title.
export function itemName(c) {
  return realTitle(c) || (c && c.code) || "Untitled item";
}

const photosText = (n) => (n === 1 ? "1 photo" : `${n} photos`);

// A candidate's pictures: the pack shot first, then the captured photos. Falls back to the
// one thumbnail (an older api, or a mirrored Shopify image) as an untagged picture.
export function itemPictures(c) {
  const imgs = Array.isArray(c && c.images) ? c.images.filter((i) => i && i.url) : [];
  if (imgs.length) return imgs;
  return c && c.thumbnailUrl ? [{ url: c.thumbnailUrl, kind: "other" }] : [];
}

// The muted line under an item's name. `lead` undefined: "In your catalog" for a titled
// item, "No title yet" for an untitled one. A string (even "") replaces it, as a row does.
export function itemLine(c, lead) {
  const imgs = Array.isArray(c && c.images) ? c.images : [];
  const pack = imgs.some((i) => i.kind === "packshot");
  const n = typeof (c && c.photoCount) === "number" ? c.photoCount : imgs.filter((i) => i.kind === "photo").length;
  const titled = Boolean(realTitle(c));
  // The Shopify image stands in for a missing pack shot: say so, not "no photos".
  const shopify = imgs.some((i) => i.kind === "shopify") || (!imgs.length && Boolean(c && c.thumbnailUrl));
  const rest = !pack && shopify ? (n ? `Shopify image + ${photosText(n)}` : "Shopify image only") : !pack && !n ? "no photos yet" : pack ? `pack shot${n ? ` + ${photosText(n)}` : ""}` : photosText(n) + (titled && lead === undefined ? " \u00b7 no pack shot yet" : "");
  return [lead === undefined ? (titled ? "In your catalog" : "No title yet") : lead, rest].filter(Boolean).join(" \u00b7 ");
}
